export default "__VITE_ASSET__B8UdE$nP__"